import { array, ord } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { Ord as NumberOrd } from "fp-ts/lib/number";
import { Ord as StringOrd } from "fp-ts/lib/string";
import {
    PartyGroupOrder,
    TUserCaseUserType,
    TUserCaseUserTypePartyGroup,
    TUserCaseUserTypePartyGroupTone,
    UserCaseUserTypePartyGroup_Tone,
    UserCaseUserType_PartyGroup,
} from "../../../domain/codecs/UserCaseUserType";

export type TPartyRoleGroup<T> = {
    label: TUserCaseUserTypePartyGroup;
    tone: TUserCaseUserTypePartyGroupTone;
    members: Array<T>;
};

type TPartyRoleGroupingProps<T> = {
    members: Array<T>;
    getUserType: (member: T) => TUserCaseUserType;
    getSortName: (member: T) => string;
};

export const groupMembersByPartyRole = <T>(props: TPartyRoleGroupingProps<T>): Array<TPartyRoleGroup<T>> =>
    pipe(
        props.members,
        array.sortBy([
            ord.contramap((member: T) =>
                PartyGroupOrder.indexOf(UserCaseUserType_PartyGroup(props.getUserType(member)))
            )(NumberOrd),
            ord.contramap((member: T) => props.getSortName(member).toLowerCase())(StringOrd),
        ]),
        array.reduce<T, Array<TPartyRoleGroup<T>>>([], (groups, member) => {
            const label = UserCaseUserType_PartyGroup(props.getUserType(member));
            const lastGroup = groups[groups.length - 1];

            return lastGroup !== undefined && lastGroup.label === label
                ? [
                    ...groups.slice(0, -1),
                    { ...lastGroup, members: [...lastGroup.members, member] },
                ]
                : [
                    ...groups,
                    {
                        label,
                        tone: UserCaseUserTypePartyGroup_Tone(label),
                        members: [member],
                    },
                ];
        }),
    );
